import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import globalRelay from '../globalRelay';
import util from '../util';
import jobCostFactory from '../models/jobCostModel';
import * as jobActions from '../jobActions';
import * as jobCostActions from '../jobCostActions';import enums from '../enum';
import componentServices from '../componentServices';
import { getCollection, ModelCollection } from '../store';

import JobSearchForm from './jobSearchForm';
import { Confirm, ContextMenu, AsyncContent, Expander, JobSearchResults, Popup, sortableComponent } from './sharedComponents';

const _accountingIDString = globalRelay.config!.getString('Accounting ID', 'job');
const _buckets = [{
	label: 'Review',
	status: 'pending-approval',
	prioritizeContracts: true
}, {
	label: 'Order Product',
	status: 'approved',
	prioritizeContracts: true
}, {
	label: 'Rejected',
	status: 'rejected'
}];
const _listStatuses = _.map(_buckets, b => b.status);

const Table = sortableComponent(({ updateSort, sortKey, list, ...childProps }) => {
	return (
		<table className="sortable interactive" cellPadding="0" cellSpacing="0">
			<TableHeader updateSort={updateSort} sortKey={sortKey} {...childProps} />
			<TableBody list={list} {...childProps} />
		</table>
	);
});

class TableHeader extends React.Component<any,any> {
	handleClick (path, e) {
		e.preventDefault();
		this.props.updateSort(path);
	}
	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}
	render () {
		const { statusType } = this.props;
		const statusPrefix = statusType === 'pending-approval' ? 'Submitted' : statusType === 'rejected' ? 'Rejected' : 'Approved';
		const statusDateOrDescriptionRow = statusType === 'rejected'
			? (<td className={this.getClassName('statusDescription')} onClick={this.handleClick.bind(this, 'statusDescription')}>Reason</td>)
			: (<td className={this.getClassName('statusDate')} onClick={this.handleClick.bind(this, 'statusDate')}>{ `${statusPrefix} on`}</td>);

		return (
			<thead>
				<tr>
					<td />
					<td className={this.getClassName('accountingId')} onClick={this.handleClick.bind(this, 'accountingId')}>{ _accountingIDString }</td>
					<td className={this.getClassName('relaySort')} onClick={this.handleClick.bind(this, 'relaySort')}>Relay No.</td>
					<td className={this.getClassName('type')} onClick={this.handleClick.bind(this, 'type')}>Type</td>
					<td className={this.getClassName('name')} onClick={this.handleClick.bind(this, 'name')}>Name</td>
					<td className={this.getClassName('customerName')} onClick={this.handleClick.bind(this, 'customerName')}>Customer</td>
					<td className={this.getClassName('statusEmployeeName')} onClick={this.handleClick.bind(this, 'statusEmployeeName')}>{ `${statusPrefix} by`}</td>
					{ statusDateOrDescriptionRow }
					<td className={this.getClassName('orderDeskOwner')} onClick={this.handleClick.bind(this, 'orderDeskOwner')}>Order Desk Owner</td>
					<td />
					<td />
				</tr>
			</thead>
		);
	}
}

const TableBody = ({ list, ...childProps }) => {
	const rows:JSX.Element[] = [];

	list.forEach((item) => {
		rows.push(<TableRow item={item} key={item.coKey || item.jobCostKey} {...childProps} />);
	});

	return (
		<tbody>
			{rows}
		</tbody>
	);
};

class TableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
		this.handleContextMenuClick = this.handleContextMenuClick.bind(this);
	}
	handleClick (e) {
		const { item } = this.props;
		const config = globalRelay.config!.withVariant(item.jobCost.companyVariant);
		const includedKeys = (config.jobCostSettings.workflow && config.jobCostSettings.workflow.includedKeys) || [];
		const lastSegment = includedKeys.some(k => k === 'pre-order') && !item.preorderSubmitted ? 'pre-order' : 'review';
		const segments = item.coKey ? [item.jobKey, 'contracts', item.jobCostKey, 'changeorder', item.coKey, lastSegment] : [item.jobKey, 'contracts', item.jobCostKey, lastSegment];

		e.preventDefault();

		componentServices.router.pushHistory(componentServices.router.pushPathSegments(segments));
	}
	handleContextMenuClick (e) {
		const { item } = this.props;
		const jobCost = item.jobCost;
		const currentEmployee = componentServices.securityContext.getCurrentEmployee();
		const changeTarget = jobCostFactory(jobCost.toDocument());
		const changeOrder = item.changeOrder && changeTarget.changeOrders.get(item.changeOrder.key);
		const existingOwner = changeTarget.getEmployeeWithRole('ordering-owner', changeOrder && changeOrder.key);

		e.stopPropagation();

		const doMarkComplete = () => {
			actions.popModal();

			(changeOrder || changeTarget).statusLog.add({ status: 'order-processed' });

			if (existingOwner) {
				changeTarget.employees.delete(existingOwner.key);
			}

			const patch = changeTarget.getPatch(jobCost);

			if (patch.length) {
				jobCostActions.saveJobCost({ jobCost: changeTarget, patch: patch });
			}
		};

		const menuItems = [{ label: 'Claim Ownership', action: () => {
			actions.popModal();

			if (existingOwner) {
				existingOwner.employeeKey = currentEmployee.key;
			}
			else {
				changeTarget.employees.add({ changeOrderKey: changeOrder && changeOrder.key, employeeKey: currentEmployee.key, role: 'ordering-owner' });
			}

			const patch = changeTarget.getPatch(jobCost);

			if (patch.length) {
				jobCostActions.saveJobCost({ jobCost: changeTarget, patch: patch });
			}
		} }];

		if (existingOwner) {
			menuItems.push({ label: 'Remove Owner', action: () => {
				actions.popModal();

				changeTarget.employees.delete(existingOwner.key);

				const patch = changeTarget.getPatch(jobCost);

				if (patch.length) {
					jobCostActions.saveJobCost({ jobCost: changeTarget, patch: patch });
				}
			} });
		}

		if (item.status === 'approved') {
			menuItems.push({ label: 'Mark Complete', action: () => {
				const confirm = <Confirm title="Mark Complete?" message="Are you sure you want to mark this complete?" confirmLabel="Mark Complete" cancelLabel="Cancel" cancelHandler={ actions.popModal } confirmHandler={ doMarkComplete } />;

				actions.popModal();
				actions.pushModal({ component: confirm });
			} });
		}

		const popup = <Popup target={e.target}><ContextMenu items={ menuItems } disableIcons={ true } /></Popup>;

		actions.pushModal({ component: popup });
	}
	render () {
		const { item } = this.props;
		const statusDateOrDescriptionRowContent = item.status === 'rejected' ? item.statusDescription : util.dateHelper.formatDate(item.statusDate, { userFriendly: true });

		return (
			<tr onClick={ this.handleClick }>
				<td />
				<td>{ item.accountingId || '-' }</td>
				<td>{ item.relayNumber }</td>
				<td>{ item.type }</td>
				<td>{ item.name }</td>
				<td>{ item.customerName }</td>
				<td>{ item.statusEmployeeName }</td>
				<td>{ statusDateOrDescriptionRowContent }</td>
				<td>{ item.ownerEmployeeName }</td>
				<td><button className="icon iconOnly contextMenu" onClick={ this.handleContextMenuClick }><span /></button></td>
				<td />
			</tr>
		);
	}
}

const _searchKey = 'order-desk-jobs-search';
export default class OrderDeskJobs extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps();
	}

	componentDidMount () {
		jobActions.fetchJobsByCriteria({ jobCostStatuses: _listStatuses });
	}

	shouldComponentUpdate (nextProps, nextState) {
		return this.props !== nextProps || this.state !== nextState;
	}

	UNSAFE_componentWillReceiveProps () {
		this.setState(this.getStateFromProps());
	}

	getStateFromProps () {
		const { store } = componentServices;
		const state = _.assign({ searchText: '' }, this.state);
		const storeJobs = getCollection({ store, collection: ModelCollection.jobs });

		if (state.modelJobs !== storeJobs) {
			state.modelJobs = storeJobs;
			const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts });
			const items:any[] = [];

			storeJobs.forEach(j => {
				const customerName = j.primaryClientContactName;
				let firstJobContract;

				jobCosts.filter(jc => jc.jobKey === j.key && jc.isContract).forEach(jc => {
					const testStatus = jc.getMostRecentStatusByStatus('approved') || jc.getMostRecentStatusByStatus('pending-approval');

					if (!firstJobContract || (testStatus && (!firstJobContract.statusDate || testStatus.dateCreated < firstJobContract.statusDate))) {
						firstJobContract = { key: jc.key, statusDate: (testStatus && testStatus.dateCreated) };
					}

					if (_listStatuses.indexOf(jc.currentStatus) !== -1) {
						const statusEmployee = this.getEmployeeByUserId(jc.currentStatusItem.createdById);
						const ownerJCEmployee = jc.getEmployeeWithRole('ordering-owner');
						const ownerEmployee = ownerJCEmployee && this.getEmployeeByKey(ownerJCEmployee.employeeKey);

						items.push({
							jobKey: j.key,
							jobCostKey: jc.key,
							accountingId: jc.accountingId,
							status: jc.currentStatus,
							statusDate: jc.currentStatusItem.dateCreated,
							statusDescription: jc.currentStatusItem.description,
							type: 'Addition',
							relaySort: jc.relayNumber.split('-')[0] + jc.relayNumber.split('-')[1].padStart(16, '0'),
							relayNumber: jc.relayNumber,
							name: jc.name,
							customerName: customerName,
							ownerEmployeeName: ownerEmployee && ownerEmployee.fullName,
							statusEmployeeName: statusEmployee && statusEmployee.fullName,
							jobCost: jc,
							preorderSubmitted: !!jc.preorderSubmittedDate
						});
					}

					_.forEach(jc.changeOrders, co => {
						if (_listStatuses.indexOf(co.currentStatus) !== -1) {
							const statusEmployee = this.getEmployeeByUserId(co.currentStatusItem.createdById);
							const ownerJCEmployee = jc.getEmployeeWithRole('ordering-owner', co.key);
							const ownerEmployee = ownerJCEmployee && this.getEmployeeByKey(ownerJCEmployee.employeeKey);

							items.push({
								jobKey: j.key,
								jobCostKey: jc.key,
								coKey: co.key,
								accountingId: co.accountingId,
								status: co.currentStatus,
								statusDate: co.currentStatusItem.dateCreated,
								statusDescription: co.currentStatusItem.description,
								type: _.startCase(co.type),
								relayNumber: co.relayNumber,
								relaySort: co.relayNumber.split('-')[0] + co.relayNumber.split('-')[1].padStart(16, '0'),
								name: co.name,
								customerName: customerName,
								ownerEmployeeName: ownerEmployee && ownerEmployee.fullName,
								statusEmployeeName: statusEmployee && statusEmployee.fullName,
								jobCost: jc,
								changeOrder: co,
								preorderSubmitted: !!jc.getSetting(enums.jobCostSettingGroups.General, `preorderSubmittedDate-co-${co.key}`)
							});
						}
					});
				});

				//  set the original contract's "type" to "Contract"
				const originalContractItem = firstJobContract && _.find(items, { type: 'Addition', jobCostKey: firstJobContract.key });
				if (originalContractItem) {
					originalContractItem.type = 'Contract';
				}
			});

			state.items = items;
		}

		return state;
	}

	getEmployeeByUserId (userId) {
		const { store } = componentServices;
		const employees = getCollection({ store, collection: ModelCollection.employees });

		return employees.find(e => e.user.key === userId);
	}

	getEmployeeByKey (key) {
		const { store } = componentServices;
		const employees = getCollection({ store, collection: ModelCollection.employees });

		return employees.find(e => e.key === key);
	}

	render () {
		const searchResults = componentServices.store.getIn(['viewState', 'searchResults', _searchKey]);
		const dashboardClasses = ['dashboard', 'orderDesk'];
		const { emptyTitle } = this.props;
		let listContent;

		if (searchResults) {
			dashboardClasses.push('searchResults');

			listContent = (<JobSearchResults
				list={ searchResults.list }
				parameterName={ searchResults.searchParameter.name }
				searchText= { searchResults.searchText }
				onJobClick= { (j) => componentServices.router.pushHistory(componentServices.router.pushPathSegments(j.key)) } />);
		}
		else {
			listContent = _.map(_buckets, bucket => {
				const sectionList = _.filter(this.state.items, { status: bucket.status });

				if (bucket.prioritizeContracts) {
					const contractList = _.filter(sectionList, { type: 'Contract' });
					const otherList = _.filter(sectionList, item => item.type !== 'Contract');
					const subGroups:JSX.Element[] = [];

					if (contractList.length) {
						subGroups.push(<Expander title="Original Contracts" contentClassNames={['inner']} isExpanded={ true } key={ `${bucket.status}-contracts` }>
							<Table list={contractList} initialSortKey="statusDate" statusType={ bucket.status } />
						</Expander>);
					}

					if (otherList.length) {
						subGroups.push(<Expander title="ADDITIONS, CHANGES & BILLING ADJUSTMENTS" contentClassNames={['inner']} isExpanded={ true } key={ `${bucket.status}-other` }>
							<Table list={otherList} initialSortKey="statusDate" statusType={ bucket.status } />
						</Expander>);
					}

					return (<Expander title={bucket.label} isExpanded={ true } key={ bucket.status }>
						{ subGroups }
					</Expander>);
				}
				else {
					return (<Expander title={bucket.label} isExpanded={ true } key={ bucket.status }>
						<AsyncContent emptyContent={ emptyTitle } hasData={ sectionList.length}><Table list={sectionList} initialSortKey="statusDate" statusType={ bucket.status } /></AsyncContent>
					</Expander>);
				}
			});
		}

		return (
			<div className={ dashboardClasses.join(' ') }>
				<JobSearchForm searchKey={ _searchKey } />
				{ listContent }
			</div>
		);
	}
}